import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1120SchM2RetainedEarningsService {

  constructor(
    private http: HttpClient
  ) {}

  saveSchdM2(
    returnClobSettingsObj: any,
    scheduleM2SaveDtls: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    const jsonObj = JSON.stringify(scheduleM2SaveDtls);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);
    
    params = _.extend({clob_data: jsonObj}, params);
    params = _.extend({clob_settings: jsonSettings}, params);
    params.process_name = "schedule-m2-grid-save";

    // CRITICAL: Explicitly ensure required parameters are included (matching error message requirements)
    // Tax year
    if (!params.tax_year) {
      params.tax_year = filterParams.tax_year || 
                        rowData.TAX_YEAR || 
                        globalService?.globalParams?.tax_year || 
                        globalService?.tax_year;
    }
    
    // Scenario
    if (!params.scenario) {
      params.scenario = filterParams.scenario || 
                        rowData.SCENARIO || 
                        globalService?.globalParams?.scenario || 
                        globalService?.scenario;
    }
    
    // JCD key
    if (!params.jcd_key) {
      params.jcd_key = filterParams.jcd_key || 
                       rowData.JCD_KEY || 
                       globalService?.globalParams?.jcd_key || 
                       globalService?.jcd_key || 
                       250; // Default fallback as per AngularJS
    }
    
    // Scenario code - ALWAYS set explicitly (required parameter)
    if (params.scenarioCode === undefined || params.scenarioCode === null || params.scenarioCode === '') {
      params.scenarioCode = params.scenario_code || 
                            filterParams.scenarioCode || 
                            filterParams.scenario_code || 
                            rowData.scenarioCode || 
                            rowData.scenario_code || 
                            rowData.SCENARIO_TYPE_CODE ||
                            globalService?.globalParams?.scenarioCode || 
                            globalService?.scenarioCode || 
                            'RAF'; // Default fallback
    }
    
    // Remove scenario_code if scenarioCode is set (avoid duplicates)
    if (params.scenarioCode && params.scenario_code) {
      delete params.scenario_code;
    }
    
    // Is issue key enabled - ALWAYS set explicitly (required parameter)
    if (params.is_issue_key_enabled === undefined || params.is_issue_key_enabled === null || params.is_issue_key_enabled === '') {
      params.is_issue_key_enabled = filterParams.is_issue_key_enabled || 
                                    rowData.is_issue_key_enabled || 
                                    globalService?.globalParams?.is_issue_key_enabled || 
                                    globalService?.is_issue_key_enabled || 
                                    'N'; // Default fallback
    }

    // Build checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "cdr_number": rowData.CDR_NO,
      "consol_group_key": rowData.CONSOL_GROUP_KEY,
      "reporting_period": rowData.REPORTING_PERIOD,
      "combination_key": rowData.COMBINATION_KEY,
      "scenario_key": parseInt(params.scenario || "1")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    
    // Add all params to URLSearchParams
    Object.keys(params).forEach(key => {
      const value = (params as any)[key];
      if (value !== undefined && value !== null) {
        urlEncoded.set(key, value.toString());
      }
    });
    
    // CRITICAL: Ensure required parameters are always included (even if empty)
    // Double-check that tax_year, scenario, jcd_key are in the payload
    if (!urlEncoded.has('tax_year')) {
      urlEncoded.set('tax_year', params.tax_year || '');
    }
    if (!urlEncoded.has('scenario')) {
      urlEncoded.set('scenario', params.scenario || '');
    }
    if (!urlEncoded.has('jcd_key')) {
      urlEncoded.set('jcd_key', params.jcd_key || '250');
    }
    if (!urlEncoded.has('scenarioCode')) {
      urlEncoded.set('scenarioCode', params.scenarioCode || 'RAF');
    }
    if (!urlEncoded.has('is_issue_key_enabled')) {
      urlEncoded.set('is_issue_key_enabled', params.is_issue_key_enabled || 'N');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const baseUrl = globalService?.generalConfigData?.base_url || '';
    const endpoint = `${baseUrl}/saveJsonObject?action_code=yvk41f`;

    return this.http.post<any>(endpoint, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

